import React from 'react';
import { Spinner } from '../Common';
import ResendOTPPage from '../ResendOTP/ResendOTPPage';
import { sendOtpSignOn } from '../../api/api';


const RESEND_COOLDOWN_SECONDS = 600; // 5 minutes = 300 seconds
const STORAGE_KEY = 'otpResendNextAt'
export default class OTPFormPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            otpNumber: '',
            errorMessage: ''
        }
    }

    onOTPChange = (e) => {
        const otpNumber = e.target.value;
        this.setState(() => ({ otpNumber }));
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.sendOTP({
            otpNumber: this.state.otpNumber,
            // hostWebsite: window.location.origin
        })
    }

    handleResendOTP = () => {
        const decoded = atob(sessionStorage.defaultID); // Base64 → string
        const [userName, password, memoryCharged, origin] = decoded.split('|');
        const cred = {
            userName: userName,
            memoryCharged: memoryCharged
        }
        sendOtpSignOn(cred).then((response) => {
            if (!response || response.status === 401 || response.ok === false) {
                throw new Error('Invalid credentials');
            } else {
                isOTPSend = true;
            }
        }).catch((error) => {
            console.log('--otpForm error--', error);
        });
    };

    render() {
        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <label >Saisissez votre code à 6 chiffres reçu par email*</label>
                        <input
                            type="text"
                            className="form-control"
                            //placeholder="Enter email"
                            autoFocus
                            value={this.state.otpNumber}
                            onChange={this.onOTPChange}
                        />
                    </div>

                    <div className="required-txt" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span>* Champs obligatoires</span>
                        <ResendOTPPage onResend={this.handleResendOTP} cooldownSeconds={600} storageKey="otpResendNextAt"></ResendOTPPage>
                    </div>
                    <div className="button-container">
                        <button type="submit" className={`btn btn-primary btn-lg spinner-${this.props.spinner}`} disabled={!this.state.otpNumber} >
                            <span>ENVOYER</span>
                            <Spinner status={this.props.spinner} />
                        </button>
                    </div>
                </form>
                <div className="bloc-form_error">
                    {this.state.errorMessage &&
                        <div className="alert alert-danger" role="alert">
                            {this.state.errorMessage}
                        </div>
                    }
                </div>
            </div>
        )
    }

}





// WEBPACK FOOTER //
// ./src/components/OTPPage/OTPFormPage.js